import { createSelector } from 'reselect';

import getElectLocationsSelector from './getElectLocationsSelector';

export default createSelector([getElectLocationsSelector], (locations) => locations.length);
